export type BrowserEnvironment =
  | 'production'
  | 'compliance-staging'
  | 'preprod'
  | 'review'
  | 'development'
  | 'unknown';

export const browserEnvironmentFromHostname = (
  hostname: string
): BrowserEnvironment => {
  const host = hostname.trim().toLowerCase().replace(/\.$/, '');

  if (host === 'myalexhealth.com' || host.endsWith('.myalexhealth.com')) {
    return 'production';
  }

  if (host.includes('compliance-staging')) {
    return 'compliance-staging';
  }

  if (host.includes('preprod')) {
    return 'preprod';
  }

  if (/(^|[.-])review([.-]|$)/.test(host)) {
    return 'review';
  }

  if (host === 'localhost' || host.endsWith('.localhost')) {
    return 'development';
  }

  return 'unknown';
};
